export const iconSize = Object.freeze({
    min: 18,
    sm: 24,
    md: 32,
    lg: 44,
    big:45,
});